import React, { Component } from 'react'
import PropTypes from 'prop-types';
import FirstPage from './RegistrationSteps/FirstPage'
import SecondPage from './RegistrationSteps/SecondPage'
import ThirdPage from './RegistrationSteps/ThirdPage'
import ForthPage from './RegistrationSteps/ForthPage'
import FifthPage from './RegistrationSteps/FifthPage'
import SixthPage from './RegistrationSteps/SixthPage'
import SeventhPage from './RegistrationSteps/SeventhPage'

import { Field, reduxForm } from 'redux-form'
import { dropdownsRequest } from '../../redux/reducers/dropdowns';
import { checkCodeRequest, resetCodeRequest } from '../../redux/reducers/checkProjectCode';
import { compose, withHandlers, withState, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { shortRegistrationRequest,registrationRequest, loginReset } from '../../redux/reducers/login';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import TextField from '../Form/TextField';
import  validate  from './validateReg';

import Spinner from '../Spinner';
import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput, MDBNotification, MDBSpinner } from "mdbreact";
import PasswordField from './PasswordField';
import EmailField from './EmailField';


class RegistrationForm extends Component {
  constructor(props) {
    super(props)
    this.nextPage = this.nextPage.bind(this)
    this.skipPages = this.skipPages.bind(this)
    this.previousPage = this.previousPage.bind(this)
    this.backToOne = this.backToOne.bind(this)
    this.firstCheck = this.firstCheck.bind(this)
    this.state = {
      page: 1,
      formActivePanel1: 1,
      formActivePanel1Changed: false,
      pageTitle:'Personal Information'
    }
  }

    
  swapFormActive = (a) => (param) => (e) => {
    
    this.setState({
      ['formActivePanel' + a]: param,
      ['formActivePanel' + a + 'Changed']: true
    });
  }
  swapFormActive2 = (a) => (param)=>{
    
    this.setState({
      ['formActivePanel' + a]: param,
      ['formActivePanel' + a + 'Changed']: true
    });
  }
    
  handleNextPrevClick = (a) => (param) => (e) => {
    this.setState({
      ['formActivePanel' + a]: param,
      ['formActivePanel' + a + 'Changed']: true
    });
  }
    
  handleSubmission = () => {
    alert('Form submitted!');
  }
    
  calculateAutofocus = (a) => {
    if (this.state['formActivePanel' + a + 'Changed']) {
      return true
    }
  }
    
  nextPage = () => {
    
    this.swapFormActive2(1)(this.state.page + 1 )
    this.setState({ page: this.state.page + 1 })
  }

  skipPages = () => {
    this.swapFormActive2(1)(6)
    this.setState({ page: 6 })
  }

  backToOne=()=> {
   
    this.props.resetCodeRequest()
    this.swapFormActive2(1)(1 )
    this.setState({ page: 1 })
  }

  previousPage=()=> {
    if(this.state.page==2){
      this.props.resetCodeRequest()
    }
    this.swapFormActive2(1)(this.state.page - 1 )
    this.setState({ page: this.state.page - 1 })
  }

  setTitle=(title)=> {
    
    this.setState({ pageTitle: title })
  }

  firstCheck=()=> {
     
     if(this.state.page==1){
      this.props.checkCodeRequest()
    }

   
  }

  render() {
    const { onSubmit,onSubmitShort, onCheck, showLoader, checkCode } = this.props
    const { page, pageTitle } = this.state
    
    return (
      
      <MDBContainer fluid>
      <div className="mainBg"></div>
      <MDBRow center  style={{alignItems: 'center', display: 'flex', height: '100vh'}}>
        <MDBCol md="6">
          <MDBCard style={{marginTop:20, marginBottom:60}} >
              <div className="header text-center  text-dark font-weight-bold pt-4 pb-2" style={{minHeight:70}}>
              {this.state.formActivePanel1 === 1 && (
                <strong>PERSONAL INFORMATION</strong>
              )}
               {this.state.formActivePanel1 === 2 && (
                <strong>CONTACT DETAILS</strong>
              )} 
              {this.state.formActivePanel1 === 3 && (
                <strong>EDUCATION &amp; STATUS</strong>
              )}
               {this.state.formActivePanel1 === 4 && (
                <strong>LEGAL DECLARATION</strong>
              )}
               {this.state.formActivePanel1 === 5 && (
                <strong>Personal Information</strong>
              )}
              </div>
              <div className='pt-4 pb-4'>
              {(this.state.formActivePanel1 !== 1 && this.state.formActivePanel1 !== 6) && <MDBStepper form>
                <MDBStep form>
                  <a href="#formstep1" >
                    <MDBBtn color={ this.state.formActivePanel1===1 ? "white" : "secondary" } circle className='border border-white'>
                      1
                    </MDBBtn>
                  </a>
                
                </MDBStep>
                <MDBStep form>
                  <a href="#formstep2" >
                    <MDBBtn color={ this.state.formActivePanel1===2 ? "white" : "secondary" } circle className='border border-white'>
                      2
                    </MDBBtn>
                  </a>
                
                </MDBStep>
                <MDBStep form>
                  <a href="#formstep3">
                    <MDBBtn color={ this.state.formActivePanel1===3 ?  "white" : "secondary" } circle className='border border-white'>
                      3
                    </MDBBtn>
                  </a>
                 
                </MDBStep>
                <MDBStep form>
                  <a href="#formstep4">
                    <MDBBtn color={ this.state.formActivePanel1===4 ?  "white" : "secondary" } circle className='border border-white'>
                      4
                    </MDBBtn>
                  </a>
                
                </MDBStep>
                <MDBStep form>
                  <a href="#formstep5" >
                    <MDBBtn color={ this.state.formActivePanel1===5 ?  "white" : "secondary" } circle className='border border-white'>
                      5
                    </MDBBtn>
                  </a>
                 
                </MDBStep>
              </MDBStepper>}
              </div>
              <MDBCardBody>
                <MDBRow>
                  {this.state.formActivePanel1 === 1 && (
                     <FirstPage onSubmit={this.firstCheck} nextPage={this.nextPage} skipPages={this.skipPages} onSubmitCoach={onSubmitShort}/>
                  )}
                  {this.state.formActivePanel1 === 2 && (
                     <ThirdPage previousPage={this.previousPage} onSubmit={this.nextPage}/>
                  )}
                  {this.state.formActivePanel1 === 3 && (
                     <SecondPage previousPage={this.previousPage} onSubmit={this.nextPage}/>
                  )}
                  {this.state.formActivePanel1 === 4 && (
                    <ForthPage previousPage={this.previousPage} onSubmit={this.nextPage}/>
                  )}

                  {this.state.formActivePanel1 === 5 && (
                    <SixthPage previousPage={this.previousPage} onSubmit={onSubmit}/>
                  )}

                  {this.state.formActivePanel1 === 6 && (
                    <SeventhPage previousPage={this.backToOne} onSubmit={onSubmitShort}/>
                  )}

                </MDBRow>
             
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        
      </MDBRow>
      {checkCode.fetching && <div style={{position:'absolute', width:'100%', height:'100%', backgroundColor:'rgba(255,255,255,0.7'}}>
        <MDBSpinner primary lg/>
        </div>}
        {console.log('HELLO', checkCode)}
      {(checkCode.error && checkCode.error.message)&& 
                    <MDBNotification
                   
                    bodyClassName="p-5 font-weight-bold grey-dark-text"
                    className="white-color"
                    closeClassName="white-text"
                    fade
                    icon="exclamation-triangle"
                    iconClassName="white-text"
                    message={checkCode.error.message}
                    show
                    title="Error"
                    titleClassName="secondary-color white-text"
                    style={{
                      position: "fixed",
                      top: "10px",
                      right: "10px",
                      zIndex: 9999
                    }}
                  
                  />
                  
               }
    </MDBContainer>
    // <div>
    //     {page === 1 && <FirstPage onSubmit={this.firstCheck} nextPage={this.nextPage} skipPages={this.skipPages}/>}
    //     {page === 2 && <SecondPage previousPage={this.previousPage} onSubmit={this.nextPage}/>}
    //     {page === 3 && <ThirdPage previousPage={this.previousPage} onSubmit={this.nextPage}/>}
    //     {page === 4 && <ForthPage previousPage={this.previousPage} onSubmit={this.nextPage}/>}
    //     {page === 5 && <FifthPage previousPage={this.previousPage} onSubmit={this.nextPage}/>}
    //     {page === 6 && <SixthPage previousPage={this.previousPage} onSubmit={onSubmit}/>}
    //     {page === 7 && <SeventhPage previousPage={this.backToOne} onSubmit={onSubmitShort}/>}
     
    //     <Modal
    //     aria-labelledby="simple-modal-title"
    //     aria-describedby="simple-modal-description"
    //     open={showLoader}
    //   >
    //     <div >
    //       <Spinner/>

    //     </div>
    //   </Modal>
    //   </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  registrationRequest: () => dispatch(registrationRequest()),
  shortRegistrationRequest: () => dispatch(shortRegistrationRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
  checkCodeRequest: () => dispatch(checkCodeRequest()),
  resetCodeRequest: () => dispatch(resetCodeRequest()),
});

const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer,
  checkCode: state.checkCodeReducer
});


export default compose(
  withStyles(styles),
  reduxForm({  form: 'registration',                 // <------ same form name
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
}),
  withState('showSpinner', 'toggleSpinner', false),
  connect(mapStateToProps, mapDispatchToProps),
  withState('showLoader', 'toggleLoader', false),
  withHandlers({
    onSubmit: props => (values) => {
      const { showLoader } = props;
      validateRegistration(values);
      //validateLogin(values);
      props.toggleLoader(!showLoader);
      props.registrationRequest();
    },
    onSubmitShort: props => (values) => {
      const { showLoader } = props;
      //validateRegistration(values);
      //validateLogin(values);
      props.toggleLoader(!showLoader);
      props.shortRegistrationRequest();
    },
    onCheck: props => (values) => {
      //validateRegistration(values);
      //validateLogin(values);
     
      //props.checkCodeRequest();
     
    },
    handleLoader: props => (values) => {
      //validateRegistration(values);
      //validateLogin(values);
     
      
    },
  }),
  lifecycle({
    componentWillMount() {
      
      !this.props.dropdowns.isFetched && this.props.dropdownsRequest();
    },
  }),
)(RegistrationForm);


const styles = () => ({
    ...commonStyles,
    halfField: {
        display: 'inline-flex',
        width: '49%',
    },
    paper: {
      position: 'absolute',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      outline: 'none',
    },
    firstInRow: {
        marginRight: '2%',
    },
    fullField: {
        width: '100%',
    },
    regFormWrapper: {
        maxWidth: '80%',
        margin: '0 auto',
    },
    rowWrapper: {
        display: 'flex',
    },
    noTopLabel: {
        paddingTop: 10,
        paddingLeft: 14,
    },
});


// WEBPACK FOOTER //
// ./src/Components/Form/RegistrationForm.jsx